import { withDefaultContextAsSelectedProject } from './api-default-context';

export const setOmniaTagAndMapElements = ({ balanceSheetData }) => {
  const { clientId, statementId, revisionId } = balanceSheetData;

  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/mapElements`,
      { ...balanceSheetData },
    )
    .then((response) => {
      return response;
    });
};

export const setOmniaAutoTagAndMapElements = ({
  clientId,
  statementId,
  revisionId,
}) => {
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/autoTagElements`,
    )
    .then((response) => {
      return response;
    });
};

export const unlinkOmniaTagAndMapElements = ({ balanceSheetData }) => {
  const { clientId, statementId, revisionId, elementIds, workpaperType } = balanceSheetData;

  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/unLinkElements`,
      { clientId, statementId, revisionId, elementIds, workpaperType },
    )
    .then((response) => {
      return response;
    });
};

export const autoTieoutForTrialBalanceRequest = (
  trailBalanceAutoTieoutPayload,
) => {
  return withDefaultContextAsSelectedProject()
    .post('/tieout/trialbalance/autotieout/workflow', {
      ...trailBalanceAutoTieoutPayload,
    })
    .then((response) => {
      return response;
    });
};

export const getTrailBalanceWorkFlowRequest = ({
  clientId,
  statementId,
  revisionId,
}) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/autotieout/workflow`,
    )
    .then((response) => {
      return response;
    });
};

export const getWorkpaperByTrialBalanceStatement = ({
  statementId,
  revisionId,
  workPaperId,
}) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/statements/${statementId}/revisions/${revisionId}/wprefs/${workPaperId}/info`,
    )
    .then((response) => {
      return response;
    });
};

export const getTrialBalanceMapedElements = ({
  statementId,
  revisionId,
  clientId,
}) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/element-data`,
    )
    .then((response) => {
      return response;
    });
};

export const getTrialBalanceTaggedElements = ({
  statementId,
  revisionId,
  clientId,
}) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/taggedElementCount`,
    )
    .then((response) => {
      return response;
    });
};

export const mapElementsInTrialBalance = ({
  clientId,
  statementId,
  revisionId,
  mappingPayload,
}) => {
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/map`,
      mappingPayload,
    )
    .then((response) => {
      return response;
    });
};

export const trialBalanceRetryRequest = (workflowData) => {
  return withDefaultContextAsSelectedProject()
    .post('/tieout/trialbalance/autotieout/workflow/retry', workflowData)
    .then((response) => {
      return response;
    });
};

export const unlinkWPReferencesInBatch = ({ balanceSheetData }) => {
  const {
    clientId,
    statementId,
    revisionId,
    workpaperType,
    elementIds,
    referenceNumber,
    workpaperRefId,
  } = balanceSheetData;
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/client/${clientId}/statement/${statementId}/revision/${revisionId}/bulk/wpref-unlink`,
      { revisionId, workpaperRefId, referenceNumber, workpaperType, elementIds },
    )
    .then((response) => {
      return response;
    });
};
